import { render, staticRenderFns } from "./noticeDisplay.vue?vue&type=template&id=1ead4f02&"
import script from "./noticeDisplay.vue?vue&type=script&lang=js&"
export * from "./noticeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports